import React from 'react';
import { KpiTile } from '../goalsTargetsTypes';
import styles from './KpiTileRow.module.css';

interface KpiTileRowProps {
  tiles: KpiTile[];
}

const icons: Record<KpiTile['icon'], string> = {
  orders: '📋',
  customers: '👥',
  upsell: '↗',
};

export const KpiTileRow: React.FC<KpiTileRowProps> = ({ tiles }) => {
  return (
    <div className={styles.row}>
      {tiles.map((tile) => (
        <div key={tile.id} className={styles.tile}>
          <div className={styles.headerRow}>
            <span className={`${styles.iconBox} ${styles[`icon_${tile.color}`]}`}>
              {icons[tile.icon]}
            </span>
            <span className={`${styles.pct} ${styles[`pct_${tile.color}`]}`}>
              {tile.pct}%
            </span>
          </div>
          <p className={styles.value}>{tile.current}</p>
          <p className={styles.label}>{tile.label}</p>
          <div className={styles.bar}>
            <span
              className={`${styles.barFill} ${styles[`bar_${tile.color}`]}`}
              style={{ width: `${tile.pct}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
